import Hero from "./components/Hero";
import Services from "./components/Services";
import WhyChooseUs from "./components/WhyChooseUs";
import AboutUs from "./components/AboutUs";
import ScheduleAppointment from "./components/ScheduleAppointment";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen">
      <Hero />
      <Services />
      <WhyChooseUs />
      <AboutUs />
      <ScheduleAppointment />
      <Contact />
      <Footer />
    </div>
  );
}
